import React from 'react';
import { Footer as UIFooter } from '@voilajsx/uikit/footer';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Mail, MapPin, Phone, Twitter } from 'lucide-react';
import { useSettingsContext } from '../context/SettingsContext';

// Configurable Footer Component using UIKit sections
export const Footer: React.FC = () => {
  const { settings } = useSettingsContext();

  return (
    <UIFooter size="xl" style={
      {"background":"#000245"}
    }>
    <div className="container mx-auto px-4 max-w-7xl">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">

            {/* Brand and Social */}
            <div>
              <div className="flex items-center space-x-2 mb-6">
                <div className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-primary">
                  <span className="font-display font-bold text-lg">TP</span>
                </div>
                <span className="font-display font-bold text-white text-lg">Tuition Point</span>
              </div>
              <p className="text-white text-opacity-80 mb-6 text-sm">
                Empowering students from kindergarten to grade 12 with personalized education and expert guidance.
              </p>
              <div className="flex space-x-4">
                <a href="#" aria-label="Facebook" className="w-10 h-10 rounded-full border border-white border-opacity-20 flex items-center justify-center text-white hover:bg-white hover:bg-opacity-10 transition-colors">
                  <Facebook className="w-4 h-4" />
                </a>
                <a href="#" aria-label="Instagram" className="w-10 h-10 rounded-full border border-white border-opacity-20 flex items-center justify-center text-white hover:bg-white hover:bg-opacity-10 transition-colors">
                  <Instagram className="w-4 h-4" />
                </a>
                <a href="#" aria-label="Twitter" className="w-10 h-10 rounded-full border border-white border-opacity-20 flex items-center justify-center text-white hover:bg-white hover:bg-opacity-10 transition-colors">
                  <Twitter className="w-4 h-4" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div>
              <h3 className="text-lg font-display font-bold mb-6">Quick Links</h3>
              <ul className="space-y-4">
                <li><Link to="/" className="text-white text-opacity-80 hover:text-opacity-100 transition-colors">Home</Link></li>
                <li><Link to="/about" className="text-white text-opacity-80 hover:text-opacity-100 transition-colors">About Us</Link></li>
                <li><Link to="/curriculum" className="text-white text-opacity-80 hover:text-opacity-100 transition-colors">Curriculum</Link></li>
                <li><Link to="/campus" className="text-white text-opacity-80 hover:text-opacity-100 transition-colors">Campus</Link></li>
                <li><Link to="/reviews" className="text-white text-opacity-80 hover:text-opacity-100 transition-colors">Reviews</Link></li>
                <li><Link to="/parent-support" className="text-white text-opacity-80 hover:text-opacity-100 transition-colors">Parent Support</Link></li>
              </ul>
            </div>

            {/* Programs */}
            <div>
              <h3 className="text-lg font-display font-bold mb-6">Programs</h3>
              <ul className="space-y-4">
                <li><Link to="/services" className="text-white text-opacity-80 hover:text-opacity-100 transition-colors">Core Subjects</Link></li>
                <li><Link to="/services" className="text-white text-opacity-80 hover:text-opacity-100 transition-colors">Specialized Programs</Link></li>
                <li><Link to="/services" className="text-white text-opacity-80 hover:text-opacity-100 transition-colors">Summer Courses</Link></li>
                <li><Link to="/services" className="text-white text-opacity-80 hover:text-opacity-100 transition-colors">Entrance Test Prep</Link></li>
                <li><Link to="/services" className="text-white text-opacity-80 hover:text-opacity-100 transition-colors">Homework Help</Link></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div>
              <h3 className="text-lg font-display font-bold mb-6">Contact Us</h3>
              <ul className="space-y-4">
                {settings?.contactAddress && (
                  <li className="flex items-start">
                    <MapPin className="w-5 h-5 mr-3 mt-0.5 text-white text-opacity-80 flex-shrink-0" />
                    <span className="text-white text-opacity-80 text-sm">{settings.contactAddress}</span>
                  </li>
                )}
                {settings?.contactPhone && (
                  <li className="flex items-start">
                    <Phone className="w-5 h-5 mr-3 mt-0.5 text-white text-opacity-80 flex-shrink-0" />
                    <span className="text-white text-opacity-80 text-sm">{settings.contactPhone}</span>
                  </li>
                )}
                {settings?.contactEmail && (
                  <li className="flex items-start">
                    <Mail className="w-5 h-5 mr-3 mt-0.5 text-white text-opacity-80 flex-shrink-0" />
                    <span className="text-white text-opacity-80 text-sm">{settings.contactEmail}</span>
                  </li>
                )}
              </ul>
            </div>
          </div>

          <div className="border-t border-gray-700 mt-12 pt-8 text-center">
            <p className="text-white text-opacity-30 text-sm">
              © {new Date().getFullYear()} Tuition Point Education Center.
            </p>
            <p className="text-white pt-1.5 text-opacity-60 text-sm">
              All rights reserved. Licensed by the Ministry of Education & Higher Education.
            </p>
          </div>
        </div>
    </UIFooter>
  );
};